<script>
import { Cell, Popup, DatetimePicker } from 'vant'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'date-selector',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell': Cell,
        'van-popup': Popup,
        'van-datetime-picker': DatetimePicker
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        label: String,
        placeholder: String,
        value: Date,
        minDate: Date,
        maxDate: Date,
        disabled: Boolean,
        readonly: Boolean,
        clearable: Boolean,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: false,
            selectedDateItem: null,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        /**
         * @getter
         * Get the area value to display on the cell item.
         */
         dateLabel() {
             let selectedLabel = ''
             const format = this.dateFormat || 'yyyy-MM-dd'
             if (this.selectedDateItem) {
                 selectedLabel = DateTimeFunc.formatDate(this.selectedDateItem, format)
             }
             else if (this.value) {
                 selectedLabel = DateTimeFunc.formatDate(this.value, format)
             }
             else if (this.placeholder) {
                 selectedLabel = this.placeholder
             }
             return selectedLabel
         },
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        value(value) {
            this.selectedDateItem = value
        },
    },

    mounted() {
        this.selectedDateItem = this.value
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onItemClick() {
            console.log('onItemClick')
            if (!this.disabled && !this.readonly) {
                if (this.selectedDateItem == null) {
                    this.selectedDateItem = new Date
                }
                this.showPopup = true
            }
        },
        onCancelBtnClick() {
            console.log('onCancelBtnClick')
            this.showPopup = false
        },
        onConfirmBtnClick() {
            console.log('onConfirmBtnClick')
            this.$emit('change-data', this.selectedDateItem)
            this.showPopup = false
        },
        onClearBtnClick() {
            console.log('onCancelBtnClick')
            this.selectedDateItem = null
            this.$emit('change-data', this.selectedDateItem)
        },
    },
}
</script>

<template>
    <!-- component -->
    <div class="date-selector van-cell no-padding">
        <van-cell 
            class="van-cell-field"
            :class="{ disabled: disabled }"
            :title="label"
            :is-link="!disabled && !readonly"
            center
            :value="dateLabel"
            @click="onItemClick"
        >
            <template #right-icon>
                <div v-if="!disabled && !readonly" class="l-inner-margin minor-color">
                    <div v-if="clearable">
                        <van-icon 
                            v-if="selectedDateItem" 
                            name="clear"
                            size="16"
                            @click.stop="onClearBtnClick"
                        />
                        <van-icon v-else name="arrow" />
                    </div>
                    <div v-else>
                        <van-icon name="arrow" />
                    </div>
                </div>
            </template>
        </van-cell>
        <van-popup 
            v-model="showPopup"
            position="bottom"
        >
            <van-datetime-picker
                v-model="selectedDateItem"
                type="date"
                :title="label"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="onCancelBtnClick"
                @confirm="onConfirmBtnClick"
            />
        </van-popup>
    </div>
</template>